var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReactions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58903 17V8.75M3 10.25V15.5C3 16.3285 3.64275 17 4.43561 17H14.0731C15.136 17 16.0398 16.1897 16.2014 15.0921L16.9745 9.84213C17.1751 8.47917 16.1659 7.25 14.8461 7.25H12.3315C11.935 7.25 11.6137 6.91422 11.6137 6.5V3.84938C11.6137 2.828 10.8212 2 9.84368 2C9.61052 2 9.39924 2.14347 9.30454 2.36609L6.7785 8.3046C6.66328 8.57545 6.40622 8.75 6.12255 8.75H4.43561C3.64275 8.75 3 9.42157 3 10.25Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactions);
export default __webpack_public_path__ + "static/media/reactions.eb909a9dac9fc6b821d84c5f0ee9c613.svg";
export { ForwardRef as ReactComponent };